import { render, staticRenderFns } from "./QuotationPriceHistoryUpdate.vue?vue&type=template&id=c510f682&"
import script from "./QuotationPriceHistoryUpdate.vue?vue&type=script&lang=js&"
export * from "./QuotationPriceHistoryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports